<template>
  <div class="onlydesktop">
    <a :href="url">
      <p class="cursos_faculdade">
        {{nome}}
      </p>
    </a>
  </div>
  <div class="onlyipad">
    <a :href="url">
      <p class="cursos_faculdade">
        {{nome}}
      </p>
    </a>
  </div>
</template>

<script>
export default {
  name: "FaculdadeCurso",
  props:["url","nome","height","ipadHeight"],
}
</script>

<style scoped>

.cursos_faculdade {
  text-align: center;
  font-family: "Montserrat SemiBold";
  font-size: 20px;
  color: #454648;
  padding: 48px 45px 62px;
}

.onlydesktop{
  display: block;
  border: 1px solid;
}
/*972*/
.onlyipad{
  display: none;
  border: 1px solid;
}

.cursos_faculdade:hover {
  color: black;
}

.onlydesktop:hover {
  border: 1px solid black;
}


@media only screen and (max-width: 1439px) {
  /*984*/
  .cursos_faculdade {
    font-size: 20px;
    padding-left: 20px;
    padding-right: 20px;
  }
}

@media (min-width : 768px)
and (max-width : 1024px){
  /*1279*/
  .cursos_faculdade {
    margin-bottom: 5px;
    padding-bottom: 90px;
  }

  /*1180*/
  .onlydesktop{
    display: none;
  }

  /*1184*/
  .onlyipad{
    display: block;
  }
}



@media (max-width: 767px) {
  /*1546*/
  .onlyipad{
    display: none;
  }

  /*1658*/
  .cursos_faculdade {
    font-size: 17px;
    padding-bottom: 20px;
    padding-top: 20px;
  }
}


@media (max-width: 839px){
  .cursos_faculdade {
    padding-bottom: 0px;
  }

  .cursos_faculdade {
    color: #454648;
    font-size: 15px;
    margin-bottom: 15px;
    line-height: 1.4;
  }



}



</style>